
// Current active configuration - Embassy screen
const signageMap = { 3665: 2578 };

// Category color mapping for WPF Mumbai - Embassy 247 (Figma colors)
const catMap = { 
  279: '#A9EFBD',  // Light green
  277: '#B9C4EF',  // Light blue
  1182: '#F9D385', // Light yellow
  1203: '#FFAAA5'  // Light red
};

const config = {
  signageMap,
  catMap
};

export default config;
